module.exports = __webpack_public_path__ + "assets/img/img-step06-01.697bdcc8.png";